import styled from 'styled-components'
import { RelSize } from '../mixins';
import theme from '../theme';
import { darken } from 'polished';

export const PreviewWrapper = styled.div`
	#header-bar {
		padding: 0;
		#file-name {
			font-size: ${RelSize(14, 16)};
			font-weight: 700;
			margin: 0;
			padding: 0;
		}
	}
	#pdf-controls {
		#pdf-toggle-pagination, #pdf-download {
			display: none;
		}
		button, a {
			box-shadow: none;
		}
	}
`;

export const DeletePageButton = styled.button`
	align-items: center;
	background-color: ${theme.red};
	border: 0;
	border-radius: ${RelSize(5, 12)};
	box-shadow: 0px 4px 4px 0 rgba(0, 0, 0, 0.1);
	color: ${theme.white};
	cursor: pointer;
	display: flex;
	font-size: ${RelSize(12, 16)};
	font-weight: 400;
	line-height: ${RelSize(15, 12)};
	margin: 0;
	padding: ${RelSize(5, 12)} ${RelSize(20, 12)};
	position: relative;
	text-align: center;
	transition: all ease-in 0.2s;
	white-space: nowrap;
	&:active, &:focus {
		border: 0;
		box-shadow: inset 2px 2px 2px rgba(0, 0, 0, 0.2);
		outline: none;
	}
	&:hover {
		background-color: ${darken(0.05, theme.red)};
		color: ${darken(0.05, theme.white)};
	}
`;

export const ShowDocumentButton = styled.button`
	align-items: center;
	background-color: ${theme.tertiaryGreen};
	border: 1px solid ${theme.primaryGreen};
	border-radius: ${RelSize(10, 14)};
	box-shadow: 0px 4px 4px 0 rgba(0, 0, 0, 0.1);
	color: ${theme.primaryGreen};
	cursor: pointer;
	display: inline-flex;
	font-size: ${RelSize(14, 16)};
	font-weight: 700;
	line-height: ${RelSize(21, 14)};
	margin: 0;
	padding: ${RelSize(15, 14)} ${RelSize(20, 14)};
	position: relative;
	text-align: center;
	transition: all ease-in 0.2s;
	&:active,
	&:focus {
		box-shadow: inset 2px 2px 2px rgba(0, 0, 0, 0.2);
		outline: none;
	}
	&:hover {
		background-color: ${darken(0.03, theme.tertiaryGreen)};
		color: ${darken(0.05, theme.primaryGreen)};
	}
`;